/**
 * Basis-Adresse der pxc-api. Laeuft sworn lokal unter *.ddev.site, wird die lokale API genutzt,
 * sonst die Live-API. So muss fuer lokale Tests nichts umgestellt und nichts zurueckgesetzt werden.
 */
var host = (typeof window !== 'undefined' && window.location) ? window.location.hostname : '';

module.exports = {
	apiBaseUrl : /\.ddev\.site$/.test(host)
		? 'https://pxc-api.ddev.site'
		: 'https://accounts-api.digitly.de'
};
